import { coreApi } from "./coreApi";

const walletApi = coreApi.injectEndpoints({
    endpoints: (builder) => ({
        acceptWithdrawal: builder.mutation({
            query: (id) => ({
                url: `/dashboard/withdrawals/${id}/approve`,
                method: "PATCH",
            })
        }),
        rejectWithdrawal: builder.mutation({
            query: (id) => ({
                url: `/dashboard/withdrawals/${id}/reject`,
                method: "PATCH",
            })
        }),
    }),
});

export const { useAcceptWithdrawalMutation, useRejectWithdrawalMutation } = walletApi;